import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const store = (state) => state.pivotTable;

const makeSelectAvailableReports = () => createSelector(
  store,
  ({ availableReports }) => availableReports,
);

const makeSelectUsedReport = () => createSelector(
  store,
  ({ usedReport }) => usedReport,
);

const makeSelectPivotTableData = () => createSelector(
  store,
  ({ pivotTableData }) => pivotTableData,
);

const makeSelectPivotTableReportType = () => createSelector(
  store,
  ({ pivotReportType }) => pivotReportType,
);

const makeSelectPivotTableTotalCount = () => createSelector(
  store,
  ({ totalCount }) => totalCount,
);

const makeSelectDefaultSearchCriteria = () => createSelector(
  store,
  ({ defaultSearchCriteria }) => defaultSearchCriteria,
);

export {
  makeSelectUsedReport,
  makeSelectPivotTableData,
  makeSelectAvailableReports,
  makeSelectPivotTableReportType,
  makeSelectPivotTableTotalCount,
  makeSelectDefaultSearchCriteria,
};
